export const convertToUsd = (amount) => Math.floor(amount / 100);

export const convertToUsdDecimal = (amount) => parseFloat((amount / 100).toFixed(2));
